export default "__VITE_ASSET__ae983038__"